(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.paragraphCarousel = {
    attach: function (context, settings) {
      $(once('paragraph-carousel', '[data-carousel]', context)).each(function () {
        var $carousel = $(this);
        var $track = $carousel.find('[data-carousel-track]').first();
        var $slides = $track.find('[data-carousel-slide]');
        var $prevBtn = $carousel.find('[data-carousel-prev]').first();
        var $nextBtn = $carousel.find('[data-carousel-next]').first();
        var $indicators = $carousel.find('[data-carousel-indicators]').first();
        var $background_colour = $indicators.data('style');
        var $colour = $indicators.data('colour');
        var slideCount = $slides.length;
        if (slideCount < 2) {
          $prevBtn.add($nextBtn).hide();
          return;
        }

        // Duplicate the end slides onto the opposite ends of the track so it
        // can keep travelling in one direction instead of snapping back.
        var $firstClone = $slides.first().clone().removeAttr('id').attr('inert', '');
        var $lastClone = $slides.last().clone().removeAttr('id').attr('inert', '');
        $track.append($firstClone);
        $track.prepend($lastClone);

        // Real slides now live at track positions 1..slideCount;
        // position 0 and slideCount+1 are the two clones.
        var currentIndex = 0;
        var trackPosition = 1;
        var autoplayDelay = parseInt($carousel.attr('data-autoplay'), 10) || 0;
        var autoplayTimer = null;
        var isSnapping = false;

        for (var i = 0; i < slideCount; i++) {
          $('<button type="button" class="carousel-dot" data-slide-index="' + i + '" aria-label="Go to slide ' + (i + 1) + '" style="' + $background_colour + ' border-color: ' + $colour + ';"></button>')
            .appendTo($indicators);
        }
        var $dots = $indicators.find('.carousel-dot');

        function updateActiveStates() {
          $slides.removeClass('is-active').attr('aria-hidden', 'true');
          $slides.eq(currentIndex).addClass('is-active').attr('aria-hidden', 'false');
          $dots.removeClass('is-active').eq(currentIndex).addClass('is-active');
        }

        function moveTrack(withTransition) {
          $track.toggleClass('no-transition', !withTransition);
          $track.css('transform', 'translateX(-' + (trackPosition * 100) + '%)');
        }

        function goToSlide(index) {
          currentIndex = (index + slideCount) % slideCount;
          trackPosition = currentIndex + 1;
          updateActiveStates();
          moveTrack(true);
        }

        function nextSlide() {
          if (isSnapping) { return; }
          trackPosition++;
          currentIndex = (currentIndex + 1) % slideCount;
          updateActiveStates();
          moveTrack(true);
        }

        function prevSlide() {
          if (isSnapping) { return; }
          trackPosition--;
          currentIndex = (currentIndex - 1 + slideCount) % slideCount;
          updateActiveStates();
          moveTrack(true);
        }

        // Once the track finishes sliding onto a clone, snap it back to the
        // matching real slide with no transition — invisible to the eye
        // because the clone and the real slide are identical.
        $track.on('transitionend', function (e) {
          if (e.target !== $track.get(0)) { return; }
          if (trackPosition === slideCount + 1) {
            isSnapping = true;
            trackPosition = 1;
            moveTrack(false);
            $track[0].offsetHeight; // force reflow before re-enabling transition
            $track.removeClass('no-transition');
            isSnapping = false;
          } else if (trackPosition === 0) {
            isSnapping = true;
            trackPosition = slideCount;
            moveTrack(false);
            $track[0].offsetHeight;
            $track.removeClass('no-transition');
            isSnapping = false;
          }
        });

        function startAutoplay() {
          if (!autoplayDelay) { return; }
          stopAutoplay();
          autoplayTimer = setInterval(nextSlide, autoplayDelay);
        }

        function stopAutoplay() {
          if (autoplayTimer) {
            clearInterval(autoplayTimer);
            autoplayTimer = null;
          }
        }

        $nextBtn.on('click', function (e) { e.preventDefault(); nextSlide(); startAutoplay(); });
        $prevBtn.on('click', function (e) { e.preventDefault(); prevSlide(); startAutoplay(); });
        $dots.on('click', function () {
          goToSlide(parseInt($(this).attr('data-slide-index'), 10));
          startAutoplay();
        });

        $carousel.on('mouseenter focusin', stopAutoplay);
        $carousel.on('mouseleave focusout', startAutoplay);

        $(document).on('visibilitychange', function () {
          document.hidden ? stopAutoplay() : startAutoplay();
        });

        updateActiveStates();
        moveTrack(false); // set the initial position with no transition
        $track[0].offsetHeight;
        $track.removeClass('no-transition');
        startAutoplay();
      });
    }
  };

})(jQuery, Drupal, once);
